import * as React from 'react';
import ReturnOrderPageView from '../layouts/ReturnOrderPageView';
import { RowDataLive } from 'src/reducers/liveorderfile';
import { RedesignReasons, RowDataCompleted } from 'src/reducers/completeorderfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
// import { UserDetail } from '../../reducers/user';

export interface ReturnOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    // onSubmit: () => void;
    // onFilesChange: () => void;
    // onFilesError: () => void;
    // btnElement: string;
    // btnType: string;
    // userDetails: UserDetail;
    liveOrderDataReturned: RowDataLive[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    approvalRequired: (array: Array<object>) => void;

    redesignReasons: RedesignReasons[];
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    redesignRequest: (columns: Object) => void;
    isDownloading: boolean;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
     // Add missing props here
     failedFiles: Array<{ fname: string; orderno: string }>;
     showFailedFilesDialog: boolean;
     failedFilesMessage: string;
     closeFailedFilesDialog: () => void;
}

class ReturnOrderPage extends React.Component<ReturnOrderPageViewProps> {
    render() {
        return (
            <ReturnOrderPageView
                onRowClick={this.props.onRowClick}
                liveOrderDataReturned={this.props.liveOrderDataReturned}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
                approvalRequired={this.props.approvalRequired}
                redesignReasons={this.props.redesignReasons}
                orderDataTat={this.props.orderDataTat}
                orderDataManufacturer={this.props.orderDataManufacturer}
                redesignRequest={this.props.redesignRequest}
                isDownloading={this.props.isDownloading}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
                // Add these new props
                failedFiles={this.props.failedFiles}
                showFailedFilesDialog={this.props.showFailedFilesDialog}
                failedFilesMessage={this.props.failedFilesMessage}
                closeFailedFilesDialog={this.props.closeFailedFilesDialog}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default ReturnOrderPage;



// WEBPACK FOOTER //
// ./src/components/ReturnOrderPage/ReturnOrderPage.tsx